/* eslint-disable */
import { useTheme } from "@mui/material/styles";
import { Box, Card, LinearProgress, Skeleton, Typography, styled } from "@mui/material";
import { useState } from "react";

const BoxWrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  "& .searchVolumeHead": {
    fontWeight: 600,
    fontSize: "18px",
  },
  "& .GlobalHead": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
    "& h2": {
      color: theme.palette.text.primary,
      fontSize: "24px",
      fontWeight: 700,
      lineHeight: "1",
    },
    "& p": {
      color: theme.palette.text.primary,
      fontSize: "15px",
      fontWeight: 600,
      lineHeight: "1",
    },
  },
  "& .GlobalVolumeWrapper": {
    marginTop: "30px",
    "& .VolumeDataBox": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "30px",
      marginBottom: "6px",
      width: "100%",
      "&:last-of-type": {
        marginBottom: "0",
      },
      "& .Country": {
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: 1,
        minWidth: "25px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      },
      "& .Value": {
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: 1,
        color: theme.palette.text.primary,
      },
      "& .ProgressWrapper": {
        flex: "1",
        position: "relative",
        "& .MuiLinearProgress-root": {
          height: "16px",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#01C0C8",
          },
        },
      },

      "& .ValueInPercent": {
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: 1,
        minWidth: "60px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#878787",
        textAlign: "right",
      },
    },
    "& .GlobalVolumeBoxSkeleton": {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      flexDirection: "column",
      marginBottom: "20px",
    },
  },
}));

function GlobalVolume({ cpcData = [], totalAvgMonthlySearches, loading = true }) {
  const theme = useTheme();
  function convertToK(value) {
    return Math.round(value / 1000);
  }
  const totalAvgMonthly = convertToK(totalAvgMonthlySearches);

  return (
    <BoxWrapper>
      <Card sx={{ padding: "24px 24px 24px 24px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important", height: "100%" }}>
        <Typography component="h2" className="searchVolumeHead">
          Search volume
        </Typography>
        <Box className="GlobalHead">
          {cpcData?.slice(0, 1).map((item, ind) => (
            <Typography component="h2" key={ind}>
              {item.avgMonthlySearches || 0}
            </Typography>
          ))}
        </Box>
        <Box className="GlobalVolumeWrapper">
          {loading
            ? Array.from({ length: 4 }).map((_, index) => (
                <Box key={index} className="GlobalVolumeBoxSkeleton">
                  <Box className="VolumeDataBox">
                    <Skeleton variant="text" width="50%" height={20} />
                    <Skeleton variant="rectangular" sx={{ flex: "1 1 20%" }} height={10} />
                    <Skeleton variant="rectangular" sx={{ flex: "1 1 20%" }} height={10} />
                  </Box>
                  <Skeleton variant="text" width="100%" height={20} />
                </Box>
              ))
            : cpcData?.map((item, ind) => {
                return (
                  <>
                    <Box sx={{ mb: "20px" }}>
                      <Box className="VolumeDataBox" key={ind} display="flex" alignItems="center">
                        <Typography component="span" className="Country" sx={{ flex: "1 1 20%", fontWeight: "bold" }}>
                          {item.locationCountry || ""}
                        </Typography>
                        <Typography component="span" className="Value" sx={{ flex: "1 1 20%", textAlign: "right" }}>
                          {item.avgMonthlySearches || 0}
                        </Typography>
                        <Typography component="span" className="ValueInPercent" sx={{}}>
                          {`${item.avgPercentage || 0}%`}
                        </Typography>
                      </Box>
                      <Box className="ProgressWrapper" sx={{ flex: "1 1 60%", display: "flex", alignItems: "center", mb: "15px" }}>
                        <LinearProgress variant="determinate" value={item.avgPercentage} sx={{ width: "100%", height: 6, borderRadius: 4 }} />
                      </Box>
                    </Box>
                  </>
                );
              })}
        </Box>
      </Card>
    </BoxWrapper>
  );
}

export default GlobalVolume;
